export default __webpack_public_path__ + "static/media/logo.53a8672c.svg";